import { render } from "./container.view.vue?vue&type=template&id=f4aa5b96&ts=true"
import script from "./container.view.vue?vue&type=script&lang=ts"
export * from "./container.view.vue?vue&type=script&lang=ts"

import "./container.view.vue?vue&type=style&index=0&id=f4aa5b96&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__